import { categoryStatus, cmsStatus } from '../action/Status';

const initialData = {
	categories: [],
	genderData: [],
};

const categoryReducer = (state = initialData, action) => {
	switch (action.type) {
		case categoryStatus.CATEGORY_GET_REQUEST:
			return {
				...state,
			};

		case categoryStatus.CATEGORY_GET_SUCCESS:
			return {
				...state,
				categories: action.payload.categories,
			};

		case categoryStatus.GENDER_REQUEST:
			return {
				...state,
			};

		case categoryStatus.GENDER_SUCCESS:
			return {
				...state,
				gender: action.payload.gender,
			};

		default:
			return state;
	}
};

export default categoryReducer;
